<template>
    <modal ok-only :id="modalId" :title="title">
        <busy-modal :show="busy" />
        <div v-if="place.id == 0 || place.airbnb_id">
            <b-table outlined striped :items="values" :fields="columns" caption-top class="mb-0" :show-empty="true">
                <template #cell(name)="data">
                    <div>
                        <div>
                            {{ data.item.name }}
                        </div>
                        <img
                            v-if="getPlaceAmenityPhoto(data.item.name)"
                            class="amenity-photo"
                            :src="getPlaceAmenityPhoto(data.item.name)"
                            alt=""
                        />
                    </div>
                </template>
                <template #cell(id)="data">
                    <label v-if="!getPlaceAmenityPhoto(data.item.name)" class="btn btn-default btn-file">
                        Upload<form-file
                            :accept="LODGIX_IMAGE_FILES_ALLOWED_EXTENSIONS.join(',')"
                            class="d-none"
                            @input="(value) => uploadPhoto(value, data.item.name)"
                            type="file"
                        />
                    </label>

                    <b-button v-else variant="default" @click="$bvModal.show('delete-photo-' + data.item.name)">
                        <font-awesome-icon :icon="['fas', 'trash']" />
                    </b-button>
                    <modal
                        :id="'delete-photo-' + data.item.name"
                        @ok="deleteAmenityPhoto(data.item.name)"
                        title="Delete Amenity Photo"
                        :hide-backdrop="true"
                    >
                        Are you sure you want to delete amenity photo?
                    </modal>
                </template>
            </b-table>
            <small>
                <a
                    target="_blank"
                    href="https://www.airbnb.com/resources/hosting-homes/a/a-guide-to-photographing-accessibility-features-30"
                >
                    Review photo guidelines
                </a>
            </small>
        </div>
        <div v-else>
            This space is not in yet in sync with Airbnb. Please try again later or manually update the property in the
            Airbnb Integration page.
        </div>
    </modal>
</template>

<script>
import api from '../../../../api';
import { formatResponseError } from '../../../../utils/api';
import Modal from '../../../generic/modal/modal.vue';
import FormFile from '../../../generic/form-file/form-file.vue';
import { RENTAL_PROPERTY_SETUP_DETAILS_ENDPOINT } from '../../../../endpoints';
import BusyModal from '../../../generic/busy-modal/busy-modal.vue';
import { LODGIX_IMAGE_FILES_ALLOWED_EXTENSIONS } from '../../../../constants';
import { mapGetters } from 'vuex';

export default {
    components: {
        Modal,
        FormFile,
        BusyModal,
    },
    props: ['modalId', 'place', 'amenities', 'placeAmenityPhoto'],
    inject: ['propertyId'],
    data() {
        return {
            file: '',
            busy: false,
            LODGIX_IMAGE_FILES_ALLOWED_EXTENSIONS,
        };
    },
    computed: {
        ...mapGetters('setupPropertyStore', ['details']),
        columns() {
            return [
                {
                    label: 'Amenity',
                    key: 'name',
                },
                {
                    label: '',
                    key: 'id',
                },
            ];
        },
        values() {
            return Object.keys(this.amenities).map((key) => ({
                name: key,
                id: this.amenities[key],
            }));
        },
        title() {
            return 'Airbnb Accessibility Verification';
        },
    },
    methods: {
        getPlaceAmenityPhoto(amenityId) {
            const placePhoto = this.placeAmenityPhoto;
            return placePhoto[this.place.id] && placePhoto[this.place.id][amenityId];
        },
        async deleteAmenityPhoto(id) {
            try {
                this.busy = true;
                await api.post(`${RENTAL_PROPERTY_SETUP_DETAILS_ENDPOINT(this.propertyId)}delete-amenity-photo/`, {
                    place_pk: this.place.id,
                    amenity: id,
                });
                this.$emit('photo-uploaded');
                this.successToast({ text: 'Photo successfuly deleted.' });
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({ text: generic || 'Could not delete photo' });
            } finally {
                this.busy = false;
            }
        },
        async uploadPhoto(value, id) {
            if (value) {
                try {
                    this.busy = true;
                    const formData = new FormData();
                    formData.append('amenity', id);
                    formData.append('photo', value);
                    formData.append('place_pk', this.place.id);
                    const { data } = await api.post(
                        `${RENTAL_PROPERTY_SETUP_DETAILS_ENDPOINT(this.propertyId)}upload-amenity-verification/`,
                        formData
                    );
                    this.$emit('photo-uploaded', data);
                    this.successToast({ text: 'Photo successfuly uploaded.' });
                } catch (e) {
                    const { generic } = formatResponseError(e);
                    this.errorToast({
                        text: generic || 'Could not upload photo',
                    });
                } finally {
                    this.busy = false;
                }
            }
        },
    },
};
</script>